export default "__VITE_ASSET__CiViJOMW__"